export default __webpack_public_path__ + "static/media/alienicon.a84affb9.png";